import { Link, useNavigate, useParams } from "react-router-dom";
import "./style.css"
import Screen from "../Layouts/Screen/Screen";
import { Helmet } from "react-helmet-async";
import { useCallback, useEffect, useRef, useState } from "react";
import { useMessage } from "../../global-components/src";
import Spinner, { LoadingThreeCircle } from "../../global-components/src/components/spinner/spiner";
import axios from "axios";
import { useAuth } from "../../global-components/src";
import { Clipboard, CreditCard, PlusCircle, UserX } from "react-feather";
import { Community, Community as NotificationType } from "../../types";
import { calculateTime } from "../../utils/TextManagerTwo";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { getImagePathBucketPacoca } from "../../global-components/src/utils/utils";
import { errorMessage } from "../../global-components/src/utils/text";
import { t } from "i18next";
import {
    getMyCommunitiesPath,
    getMyCommunitiesStorageKey,
    mergeMyCommunitiesPage,
} from "./my-communities";

const Communities = () => {
    const observerRef = useRef<IntersectionObserver | null>(null);
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const [communities, setCommunities] = useState<NotificationType[] | null>(null);    
    const { setMessage } = useMessage();
    const [loading, setLoading] = useState(false);
    const [end, setEnd] = useState(false);
    const [page, setPage] = useState(() => { return 1;});
    const { token, user } = useAuth();
    const navigate = useNavigate();

    const loadData = async (newPage?: number) => {
        if (!user?.id) return;

        const currentPage = newPage ?? page + 1; // Usa newPage se fornecido, senão incrementa
        const cacheKey = getMyCommunitiesStorageKey(user.id);

        if (loading || end) return;

        // Exibe somente o cache da primeira página enquanto a resposta atualiza a lista.
        if (currentPage === 1) {
            const localData = localStorage.getItem(cacheKey);
            if (localData) {
                try {
                    setCommunities(JSON.parse(localData));
                } catch (e) {
                    console.warn("Erro ao ler comunidades locais:", e);
                }
            }
        }

        setLoading(true);

        try {
            const response = await axios.get(PACOCA_API_URL + getMyCommunitiesPath(user.id, currentPage), {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const fetchedCommunities: Community[] = response.data.communities || [];

            if (fetchedCommunities.length > 0) {
                setCommunities((prevData) => {
                    const updated = mergeMyCommunitiesPage(prevData || [], fetchedCommunities, currentPage);

                    localStorage.setItem(cacheKey, JSON.stringify(updated));
                    return updated;
                });

            } else {
                if (currentPage === 1) {
                    setCommunities([]);
                    localStorage.removeItem(cacheKey);
                }
                setEnd(true);
            }

        } catch (err: any) {
           const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
            console.error('Erro:', messageError);
            setEnd(true)
        } finally {            
            setLoading(false);
        }
    };

    useEffect(() => {
        const modalBody = document.getElementById("modal-comments-body");

        const handleScroll = () => {
            if (!modalBody) return;
            const { scrollTop, clientHeight, scrollHeight } = modalBody;

            if ((scrollTop + clientHeight >= scrollHeight - 50) && !end && !loading) {
                setPage((prevPage) => prevPage + 1); // Agora a página é atualizada antes da requisição
            }
        };

        if (modalBody) {
            modalBody.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (modalBody) {
                modalBody.removeEventListener("scroll", handleScroll);
            }
        };
    }, [end, loading]);

    useEffect(() => {
        loadData(page);
    }, [page]);

    const observerCallback = useCallback(
        (entries: IntersectionObserverEntry[]) => {
            const target = entries[0];
            if (target.isIntersecting && !loading && !end) {
                // setPage((prev) => prev + 1);
            }
        },
        [loading, end]
    );

    useEffect(() => {
        if (endOfListRef.current) {
            observerRef.current = new IntersectionObserver(observerCallback, {
                root: null,
                rootMargin: "200px",
                threshold: 0.1
            });

            observerRef.current.observe(endOfListRef.current);
        }

        return () => observerRef.current?.disconnect();
    }, [observerCallback]);

    useEffect(() => {
        // Salva a posição de rolagem quando o feed for modificado
        const handleScroll = () => {
            sessionStorage.setItem("scrollPosition", window.scrollY.toString());
        };

            window.addEventListener("scroll", handleScroll)

        return () => {
                window.removeEventListener("scroll", handleScroll)
        };
    }, []);

    return (
        <div className="container-community">
             <Screen paddingTopTitle={true} title={t("communities.myCommunities")}>
                <Helmet>
                        <title>Paçoca - {t("communities.myCommunities")}</title>
                        <meta name="description" content={`Minhas Comunidades do Paçoca, a rede dos brasileiros!`}/>
                        <meta name="keywords" content={`Paçoca, rede social brasileira, Comunidades, grupos}`}/>
                        <meta name="author" content="Paçoca Inc."/>
                        <meta property="og:title" content={`Paçoca - ${t("communities.myCommunities")}`}/>
                        <meta property="og:description" content={`Minhas Comunidades do Paçoca, a rede dos brasileiros`}/>
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:type" content="website"/>
                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={`Paçoca - Comunidades`}/>
                        <meta name="twitter:description" content={`Minhas Comunidades do Paçoca, a rede dos brasileiros`}/>
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <>
                    <>
                        <div style={{marginBottom: "10px"}} onClick={() => navigate(`/comunidades/novo`)} className={`user-select-none row-notification row-community`}>
                            <PlusCircle/>
                            <div className="col" style={{paddingLeft: "10px"}}>
                                <h5><a className="name-search">{t("communities.createCommunity")}</a></h5>
                            </div>
                        </div>

                        {communities?.map((c) => {
                            return (
                                <div onClick={() => navigate(`/comunidades/${c.id}`)} key={c.id} className={`row-notification row-community`}>
                                    <img src={`${getImagePathBucketPacoca(c?.img)}`} alt="Imagem da comunidade" className="user-select-none img-account-search"  onError={(e) => { e.currentTarget.src = "/img/img-placeholder.jpg"; }} />
                                    <div className="col" style={{paddingLeft: "10px", textWrap: "nowrap", overflow: "hidden"}}>
                                        <h5><a className="name-search">{c.name}</a></h5>
                                        <p>{c.description}</p>
                                    </div>
                                </div>
                            );
                        })}

                        {!loading ? (
                            <div className="user-select-none row row-empty-comment" style={{marginLeft: "-40px", marginTop: "-40px"}}>
                                <span className="span-empty">
                                    {!communities?.length && (
                                        <>
                                            <UserX className="icon-empty" />
                                            <h3 className="w-100 text-center">{t("empty.communitys")}</h3>
                                        </>
                                    )}
                                    <p><Link to={"/pesquisa?tipoFeed=group"}>{t("communities.exploreCommunities")}</Link></p>
                                </span>
                            </div>
                        ): null}

                        {loading && (
                            <>
                                {[...Array(communities?.length ? 1 : 5)].map((_, index) => (
                                    <div className="row-notification open-notification row-user">
                                        <span className="user-select-none col-1 img-account-search img-notification placeholder"/>
                                        <div className="col" style={{ paddingLeft: "5px", overflow: "hidden",  }}>
                                            <h5 className="h5-name-search name-card-search-user" style={{ overflowWrap: "anywhere", whiteSpace: "nowrap", overflow: "hidden", marginBottom: "2px" }}>
                                                <span className="name-search" style={{ marginRight: 5 }}>
                                                <div className="placeholder" style={{height: "10px", width: "90%"}}></div>
                                                </span>
                                            </h5>
                                            <p className="username-search" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                                                <span className="placeholder mt-1" style={{height: "10px", width: "100px"}}></span>
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </>
                        )}

                        <p ref={endOfListRef}></p>
                    </>
                        

                    
                </>
            </Screen>
        </div>
    );
};

export default Communities;